import { apiHelper, sharedHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const menuService = {
    getAllMenus,
    getMenu,
    updateMenu,
    createMenu,
    updateMenuStatus,
    clone,
    cloneAll
};

const MODULE = {
    MENU: 'company-menus',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllMenus(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['company_uuid'] = sessionHelper.getStaffCompanyUUID()
    }

    return apiHelper(API_URL).get(`/${MODULE.MENU}`, requestOptions)
}

export function getMenu(id) {
    return apiHelper(API_URL).get(`/${MODULE.MENU}/${id}`)
}

export function updateMenu(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);
    sharedHelper.appendIfNotNull(formData, 'remark', data.remark);
    formData.append('_method', 'PUT');

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    if (data.icon instanceof File) {
        formData.append('icon', data.icon);
    }

    return apiHelper(API_URL).post(`/${MODULE.MENU}/${data.id}`, formData)
}

export function createMenu(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);
    sharedHelper.appendIfNotNull(formData, 'remark', data.remark);

    if (data.icon != null && data.icon instanceof File) {
        formData.append('icon', data.icon);
    }

    data.names.forEach((name, index) => {
        formData.append(`name[${index}][language_code]`, name.language.code);
        formData.append(`name[${index}][value]`, name.name);
    });

    return apiHelper(API_URL).post(`/${MODULE.MENU}`, formData)
}

export function updateMenuStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.MENU}/${data.id}`, requestOptions)
}

export function clone(data) {
    const requestOptions = {
        menu_uuid: data.menuID,
        to_company_uuid: data.companyID
    }

    return apiHelper(API_URL).post(`/${MODULE.MENU}/clone`, requestOptions)
}

export function cloneAll(data) {
    const requestOptions = {
        from_company_uuid: data.fromCompanyID,
        to_company_uuid: data.companyID
    }

    return apiHelper(API_URL).post(`/${MODULE.MENU}/clone/all`, requestOptions)
}